import { useState } from 'react';

import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';

import TableCRUDLayout, {
  TableCRUDLayoutHandlers
} from 'components/shared/CRUD/TableCRUDLayout';

import EmployerCostSettings from './components/EmployerCostSettings';

import { useDelete } from './hooks/useDelete';
import { useGetColumnDefs } from './hooks/useGetColumnDefs';
import { useGetTableData } from './hooks/useGetTableData';

const EmployerCostSettingsGrid = () => {
  const { t: tEmp } = useTranslation('common', {
    keyPrefix: 'employerCostSettings'
  });
  const { t } = useTranslation('common');
  const columns = useGetColumnDefs();
  const { data, isFetching } = useGetTableData();
  const [isCopy, setIsCopy] = useState(false);
  const { mutate: deleteRow } = useDelete();

  const onCopy = (id, row, props: TableCRUDLayoutHandlers) => {
    setIsCopy(true);
    if (props?.handleEditClick) {
      props.handleEditClick(id, row);
    }
  };

  const clearEdit = () => {
    setIsCopy(false);
  };

  const onDelete = (id) => {
    deleteRow(id);
  };

  return (
    <>
      <TableCRUDLayout
        FormComponent={EmployerCostSettings}
        additionalFormProps={{ isCopy: isCopy }}
        columns={columns}
        rows={data}
        loading={isFetching}
        confirmationTitle={tEmp('confirmationTitle')}
        confirmationBody={tEmp('confirmationBody')}
        onDeleteClick={onDelete}
        getRowId={(row) => row.employerDynId}
        customActions={[
          {
            tooltipTitle: t('copy'),
            icon: faCopy,
            onClick: onCopy
          }
        ]}
        drawerProps={{
          PaperProps: {
            sx: {
              width: 450
            }
          }
        }}
        onClose={clearEdit}
      />
    </>
  );
};

export default EmployerCostSettingsGrid;
